export default {"src":"/_next/static/media/tasting_and_pairing.fe39148c.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};